/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Billing_Load_ErrorInputs */



/**
* | output |
* | --- |
* | "Your bills could not be loaded. Please try again." |
*
* @param {Partner_Billing_Load_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_load_error = /** @type {((inputs?: Partner_Billing_Load_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Load_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ihre Abrechnungen konnten nicht geladen werden. Bitte versuchen Sie es erneut.")
	return /** @type {LocalizedString} */ ("Your bills could not be loaded. Please try again.")
});